module.exports = __webpack_public_path__ + "static/media/bg-agences-de-location.988585dd.jpg";